import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import { useCallback } from 'react';
import { createMttUserStartOutbound } from '../../api/outbound/mttStagingOutbounds';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { useAppSelector } from '../../redux/store';
export const MttStagingStartButtonContainer = () => {
    const socketSend = useSocketSend();
    const isTourneyOwner = useAppSelector((state) => state.mttStaging.isTourneyOwner);
    const onClick = useCallback(() => {
        socketSend(createMttUserStartOutbound());
    }, [socketSend]);
    if (!isTourneyOwner) {
        return null;
    }
    return (_jsx(Button, { variant: 'contained', color: 'secondary', onClick: onClick, children: "Start" }));
};
